import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/simplex-wit.svg'


const _hoisted_1 = {
  key: 0,
  class: "auth-brand-panel"
}
const _hoisted_2 = { class: "auth-content" }
const _hoisted_3 = { class: "auth-card" }
const _hoisted_4 = {
  key: 0,
  class: "auth-logo-dark",
  src: _imports_0,
  alt: "Simplex"
}
const _hoisted_5 = { class: "auth-card-heading" }
const _hoisted_6 = {
  key: 0,
  class: "auth-eyebrow"
}
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["auth-page", { "auth-page--status": _ctx.status }])
  }, [
    (!_ctx.status)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createStaticVNode("<div class=\"auth-brand-content\" data-v-23f81991><img class=\"auth-logo\" src=\"" + _imports_0 + "\" alt=\"Simplex\" data-v-23f81991><div class=\"auth-brand-kicker\" data-v-23f81991>Veilig inloggen</div><h2 data-v-23f81991>Automatiseer je processen. Op één plek.</h2><p data-v-23f81991>Bouw, plan en monitor koppelingen tussen AFAS en je andere systemen met Simplex Flow.</p><div class=\"auth-brand-points\" data-v-23f81991><div class=\"auth-brand-point\" data-v-23f81991><i class=\"fas fa-shield-alt\" data-v-23f81991></i><span data-v-23f81991>Beveiligde toegang via de Simplex AppStore</span></div><div class=\"auth-brand-point\" data-v-23f81991><i class=\"fas fa-lock\" data-v-23f81991></i><span data-v-23f81991>Wachtwoorden en tokens versleuteld opgeslagen</span></div><div class=\"auth-brand-point\" data-v-23f81991><i class=\"fas fa-project-diagram\" data-v-23f81991></i><span data-v-23f81991>Visuele Flow editor</span></div></div></div>", 1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.status)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["auth-icon", { "auth-icon--error": _ctx.error }])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon)
            }, null, 2)
          ], 2),
          (_ctx.eyebrow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.eyebrow), 1))
            : _createCommentVNode("", true),
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}